<script>
    import {
        beyondTopPlayers,
        countUpPlayers,
        dealADartPlayers,
        names,
        players,
        shanghaiPlayers,
        tacticsPlayers,
        suddenDeathPlayers,
        killerPlayers,
        roundTheBoardPlayers,
        highLowPlayers
    } from './store';
    import Players from './components/Players.svelte';
    import HalfIt from './components/HalfIt.svelte';
    import {Player} from './player.model';
    import RoundTheBoard from "./components/RoundTheBoard.svelte";
    import Tactics from "./components/Tactics.svelte";
    import {TacticsPlayer} from "./tactics.model";
    import CountUp from "./components/CountUp.svelte";
    import {CountUpPlayer} from "./countup.model";
    import BeyondTop from "./components/BeyondTop.svelte";
    import {BeyondTopPlayer} from "./beyondtop.model";
    import Shanghai from "./components/Shanghai.svelte";
    import {ShanghaiPlayer} from "./shanghai.model";
    import {DealADartPlayer} from "./dealadart.model";
    import DealADart from "./components/DealADart.svelte";
    import SuddenDeath from "./components/SuddenDeath.svelte";
    import {SuddenDeathPlayer} from "./suddendeath.model";
    import {HistoryEventType} from "./history-events.enum";
    import {SpinningWheelCategory, SpinningWheelItemModel} from "./spinning-wheel-item.model";
    import {KillerPlayer} from "./killer.model";
    import Killer from "./components/Killer.svelte";
    import {RoundTheBoardPlayer} from "./roundtheboard.model";
    import {HighLowPlayer} from "./highlow.model";
    import HighLow from "./components/HighLow.svelte";

    let started = false;
    let gameType;
    let props;

    function startHalfIt(event) {
        started = true;
        gameType = "half-it";

        let spinningWheelData = [
            new SpinningWheelItemModel("+ 25 points", HistoryEventType.SPINNING_WHEEL_PLUS_25_POINTS, SpinningWheelCategory.LUCKY),
            new SpinningWheelItemModel("Use other arm", HistoryEventType.SPINNING_WHEEL_USE_OTHER_ARM, SpinningWheelCategory.BAD),
            new SpinningWheelItemModel("Score times 2!", HistoryEventType.SPINNING_WHEEL_SCORE_TIMES_TWO, SpinningWheelCategory.LUCKY),
            new SpinningWheelItemModel("Step 1 meter back", HistoryEventType.SPINNING_WHEEL_ONE_METER_BACK, SpinningWheelCategory.UNLUCKY),
            new SpinningWheelItemModel("+ 3 darts", HistoryEventType.SPINNING_WHEEL_PLUS_THREE_DARTS, SpinningWheelCategory.LUCKY),
            new SpinningWheelItemModel("- 25 points", HistoryEventType.SPINNING_WHEEL_MINUS_25_POINTS, SpinningWheelCategory.UNLUCKY),
            new SpinningWheelItemModel("1 hit if missed", HistoryEventType.SPINNING_WHEEL_ONE_HIT, SpinningWheelCategory.LUCKY),
            new SpinningWheelItemModel("Sit down", HistoryEventType.SPINNING_WHEEL_SIT_DOWN, SpinningWheelCategory.UNLUCKY)
        ];

        let roundsToPlay = [];
        if (event.detail.halfItQuickGame) {
            roundsToPlay = ['Scoring round', '19', '20', 'Bull'];
        } else if (event.detail && event.detail.roundModeReversed) {
            roundsToPlay = ['20', '19', 'Double', '18', '17', 'Triple', '16', '15', 'Bull'];
        } else {
            roundsToPlay = ['15', '16', 'Triple', '17', '18', 'Double', '19', '20', 'Bull'];
        }

        props = {
            rounds: roundsToPlay,
            funHalfIt: event.detail.funHalfIt,
            luckyLevel: event.detail.luckyLevel,
            spinningWheelData: spinningWheelData,
            halfItQuickGame: event.detail.halfItQuickGame,
            roundModeReversed: event.detail.roundModeReversed
        };

        players.update(players => players.map(player => new Player(player.name, roundsToPlay, event.detail.halfItQuickGame)));
        $players = $players.sort(() => Math.random() - 0.5)
    }

    function startRoundTheBoard(event) {
        roundTheBoardPlayers.update(players => players.map(player => new RoundTheBoardPlayer(player.name, [])));
        $roundTheBoardPlayers = $roundTheBoardPlayers.sort(() => Math.random() - 0.5)

        let start = 20;
        let end = 1;
        let nrOfBulls = event.detail.roundTheBoardNrOfBulls;
        if (event.detail.roundTheBoardQuickGame) {
            end = 10;
        }

        let roundsToPlay = [];
        for (let i = start; i >= end; i--) {
            roundsToPlay.push(i.toString());
        }

        for (let i = 1; i <= nrOfBulls; i++) {
            roundsToPlay.push("Bull " + i.toString())
        }

        started = true;
        gameType = "round-the-board";
        props = {rounds: roundsToPlay, roundTheBoardQuickGame: event.detail.roundTheBoardQuickGame, roundTheBoardNrOfBulls: nrOfBulls};
    }

    function startTactics() {
        tacticsPlayers.update(tacticsPlayers => tacticsPlayers.map(player => new TacticsPlayer(player.name)));
        $tacticsPlayers = $tacticsPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "tactics";
    }

    function startBeyondTop(event) {
        let nrOfLives = 6;
        let nrOfRounds = 10;
        if (event.detail.beyondTopQuickGame) {
            nrOfLives = 3;
            nrOfRounds = 5;
        }

        beyondTopPlayers.update(beyondTopPlayers => beyondTopPlayers.map(player => new BeyondTopPlayer(player.name, nrOfLives, nrOfRounds)));

        $beyondTopPlayers = $beyondTopPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "beyond-top";
        props = {beyondTopQuickGame: event.detail.beyondTopQuickGame, rounds:  Array.from({length: nrOfRounds}, (_, i) => i + 1)};
    }

    function startShanghai() {
        shanghaiPlayers.set([]);
        let rounds = ['15', '16', '17', '18', '19', '20'];

        $names.forEach((playerName) => {
            shanghaiPlayers.update(players => [...players, new ShanghaiPlayer(playerName, rounds)]);
        })

        $shanghaiPlayers = $shanghaiPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "shanghai";
        props = {rounds: rounds};
    }

    function startCountUp(event) {
        countUpPlayers.update(countUpPlayers => countUpPlayers.map(player => new CountUpPlayer(player.name, event.detail.nrOfRounds)));
        $countUpPlayers = $countUpPlayers.sort(() => Math.random() - 0.5)

        props = {rounds: Array.from({length: event.detail.nrOfRounds}, (_, i) => i + 1)};

        started = true;
        gameType = "count-up";
    }

    function startDealADart() {
        dealADartPlayers.set([]);

        names.subscribe((playerNames) => {
            playerNames.forEach(name => {

                const oneToTwenty = Array.from(new Array(20), (x, i) => i + 1);
                const singleOptions = oneToTwenty.slice();
                singleOptions.push('Single Bull');

                const doubleOptions = oneToTwenty.slice();
                doubleOptions.push('Double Bull');

                const single = singleOptions[Math.floor(Math.random() * singleOptions.length)];
                const double = doubleOptions[Math.floor(Math.random() * doubleOptions.length)];
                const triple = oneToTwenty[Math.floor(Math.random() * oneToTwenty.length)];

                dealADartPlayers.update(dealADartPlayers => [...dealADartPlayers, new DealADartPlayer(name, single, double, triple)]);
            });
        })


        $dealADartPlayers = $dealADartPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "deal-a-dart";
    }

    function startSuddenDeath() {
        suddenDeathPlayers.set([]);

        names.subscribe((playerNames) => {
            playerNames.forEach(name => {
                suddenDeathPlayers.update(suddenDeathPlayers => [...suddenDeathPlayers, new SuddenDeathPlayer(name, playerNames.length - 1)]);
            });
        });

        $suddenDeathPlayers = $suddenDeathPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "sudden-death";
    }

    function startKiller() {
        killerPlayers.set([]);

        let oneToTwenty = Array.from(new Array(20), (x, i) => i + 1);

        names.subscribe((playerNames) => {
            playerNames.forEach(name => {
                const selectedNumber = oneToTwenty[Math.floor(Math.random() * oneToTwenty.length)];
                const index = oneToTwenty.indexOf(selectedNumber);
                oneToTwenty.splice(index, 1); // remove selected number to prevent duplicates

                killerPlayers.update(killerPlayers => [...killerPlayers, new KillerPlayer(name, selectedNumber)]);
            });
        });

        $killerPlayers = $killerPlayers.sort(() => Math.random() - 0.5)

        started = true;
        gameType = "killer";
    }

    function startHighLow(event) {
        const lives = event.detail.lives;
        highLowPlayers.set([]);
        $names.forEach(name => {
            highLowPlayers.update(players => [...players, new HighLowPlayer(name, lives)]);
        });
        $highLowPlayers = $highLowPlayers.sort(() => Math.random() - 0.5);

        started = true;
        gameType = "high-low";
        props = {lives};
    }

    function newGame() {
        started = false;
        gameType = '';
    }

</script>

{#if !started}
    <Players on:startHalfIt={startHalfIt}
             on:startRoundTheBoard={startRoundTheBoard}
             on:startTactics={startTactics}
             on:startCountUp={startCountUp}
             on:startBeyondTop={startBeyondTop}
             on:startShanghai={startShanghai}
             on:startDealADart={startDealADart}
             on:startSuddenDeath={startSuddenDeath}
             on:startKiller={startKiller}
             on:startHighLow={startHighLow}
    />
{/if}


{#if $names.length > 0 && gameType === "half-it"}
    <HalfIt on:reset={startHalfIt} on:newGame={newGame} {...props}/>
{/if}

{#if $names.length > 0 && gameType === "round-the-board"}
    <RoundTheBoard on:reset={startRoundTheBoard} on:newGame={newGame} {...props}/>
{/if}

{#if $names.length > 0 && gameType === "tactics"}
    <Tactics on:reset={startTactics} on:newGame={newGame}/>
{/if}

{#if $names.length > 0 && gameType === "count-up"}
    <CountUp on:reset={startCountUp} on:newGame={newGame} {...props}/>
{/if}

{#if $names.length > 0 && gameType === "shanghai"}
    <Shanghai on:reset={startShanghai} on:newGame={newGame} {...props}/>
{/if}

{#if $names.length > 0 && gameType === "beyond-top"}
    <BeyondTop on:reset={startBeyondTop} on:newGame={newGame} {...props}/>
{/if}

{#if $names.length > 0 && gameType === "deal-a-dart"}
    <DealADart on:reset={startDealADart} on:newGame={newGame}/>
{/if}

{#if $names.length > 0 && gameType === "sudden-death"}
    <SuddenDeath on:reset={startSuddenDeath} on:newGame={newGame}/>
{/if}

{#if $names.length > 0 && gameType === "killer"}
    <Killer on:reset={startKiller} on:newGame={newGame}/>
{/if}

{#if $names.length > 0 && gameType === "high-low"}
    <HighLow on:reset={startHighLow} on:newGame={newGame} {...props}/>
{/if}
